export default "__VITE_ASSET__DmaXBNea__"